import React, { useContext } from "react";
import Settings from "../../settings";
import useSWR from "swr";
import { CurrentPriceResponse, fetcher, isinUrl, REFRESH_TIME_LONG } from "../../widgets/data";
import { numberWithCommas } from "../../widgets/formatters";
import { format } from "date-fns/esm";

export default function SharePriceHeader() {
  const { getSetting } = useContext(Settings);

  const { data } = useSWR<CurrentPriceResponse>(
    isinUrl("price", getSetting("sharePriceGlobal.isin")),
    fetcher,
    { refreshInterval: REFRESH_TIME_LONG }
  );

  if (!data) return null;

  const fetched = data?.current.isoTimestamp
    ? new Date(data.current.isoTimestamp)
    : null;


  return (
    <>
      <div className={`share-price-header ${data.change.direction}`}>
        <div className="share-price-header__title-container">
          <a href="https://www.mpevans.co.uk/investors/market-prices/share-price">
            <p className="share-price-header__title">Share</p>
            <p className="share-price-header__title">price:</p>
          </a>
        </div>
        <div className="share-price-header__meta">
          {getSetting("sharePriceHeader.sections.showDirectionArrow") && (
            <svg fill="none" height="10" viewBox="0 0 7 6" width="10" xmlns="http://www.w3.org/2000/svg">
              <path d="m3.67189.4375 2.73341 4.7344h-5.466816z" fill="#245240" />
            </svg>
          )}
          {getSetting("sharePriceHeader.sections.showDirectionArrow") && (
            <div className="share-price-header__change-amount">{Math.abs(Number(data.change.pct))}%</div>
          )}
        </div>
        <div className="current-price">
          {numberWithCommas(data.current.close, 0)}
        </div>
      </div>
    </>
  )
}
